import { createMemo } from "solid-js";
import {
  type AdminCapability,
  type AdminRole,
  assignableRolesFor,
  canAdministerUser,
  roleCan,
} from "@aula/shared";
import { useSession } from "@/lib/auth";

/**
 * Reactive view of the current admin's role + capability checks. Mirrors the
 * backend capability map (`@aula/shared` `capabilities`) so the back-office UI
 * never offers an action that would 403. The backend stays the source of truth.
 */
export function useAdminCapabilities() {
  const session = useSession();
  const role = createMemo(() => session.data?.user.role);
  const can = (capability: AdminCapability) => roleCan(role(), capability);
  /** Roles that THIS actor can grant (never exceeding their own). */
  const assignableRoles = createMemo<readonly AdminRole[]>(() => assignableRolesFor(role()));
  /** Can the actor manage a user whose CURRENT role is `targetRole`? */
  const canAdminister = (targetRole: string | null | undefined) =>
    canAdministerUser(role(), targetRole);
  return { role, can, assignableRoles, canAdminister };
}
